import { useEffect, useState } from 'react';

type Props = {
  page: number;
  total: number;
  pageSize: number;
  loading: boolean;
  onChange: (page: number) => void;
};

export default function RecordsPagination({ page, total, pageSize, loading, onChange }: Props) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(page + 1, pages);
  const [input, setInput] = useState(String(current));
  const [error, setError] = useState('');
  const disabled = loading || total === 0;

  useEffect(() => {
    setInput(String(current));
    setError('');
  }, [current, pages]);

  function jump() {
    if (disabled) return;
    const value = input.trim();
    const target = Number(value);
    if (!/^\d+$/.test(value) || !Number.isInteger(target) || target < 1 || target > pages) {
      setError(`请输入 1–${pages} 之间的整数页码`);
      return;
    }
    setInput(String(target));
    setError('');
    onChange(target - 1);
  }

  return <nav className="pagination records-pagination" aria-label="提交记录分页">
    <span aria-live="polite">第 {current} / {pages} 页</span>
    <div className="records-pagination-controls">
      <button type="button" className="page-btn records-page-button" disabled={disabled || current === 1} onClick={() => onChange(current - 2)}>上一页</button>
      <button type="button" className="page-btn records-page-button" disabled={disabled || current === pages} onClick={() => onChange(current)}>下一页</button>
      <button type="button" className="page-btn records-page-button" disabled={disabled || current === pages} onClick={() => onChange(pages - 1)}>末页</button>
      <form className="records-page-jump" noValidate onSubmit={(event) => { event.preventDefault(); jump(); }}>
        <label htmlFor="records-page-number">跳至</label>
        <input id="records-page-number" aria-label="跳转页码" type="number" inputMode="numeric" min={1} max={pages} step={1} value={input} disabled={disabled} aria-invalid={!!error} aria-describedby={error ? 'records-page-error' : undefined} onChange={(event) => { setInput(event.target.value); setError(''); }} />
        <span>页</span>
        <button type="submit" className="page-btn records-page-button" disabled={disabled}>跳转</button>
      </form>
    </div>
    {error && <span id="records-page-error" className="records-page-error" role="alert">{error}</span>}
  </nav>;
}
